import React from "react"

export const HummerSvg = ({ width, height, color }) => (
  <svg width={width ?? "12"} height={height ?? "12"} viewBox="0 0 12 12" fill={color ?? "#9EACB0"} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1525_3459)">
      <path d="M6.00878 3.71484L0.277789 10.0373C0.277789 10.0373 -0.346138 10.8216 0.277789 11.627C0.277789 11.627 0.77693 12.2054 1.87565 11.5241L7.23229 4.66564L6.00878 3.71484Z" />
      <path d="M9.8191 6.41694L8.66256 5.47523C8.66256 5.47523 9.03996 4.585 8.07515 4.23678C8.07515 4.23678 7.36601 4.261 7.23514 4.66676L6.00859 3.71596C6.00859 3.71596 6.63556 2.22922 5.62814 1.38743C5.62814 1.38743 5.00726 0.821196 4.17333 0.809084C4.17333 0.809084 3.40636 0.809084 4.02724 0.348828C4.02724 0.348828 5.57032 -0.53232 7.42383 0.506284L9.56953 2.3352C9.56953 2.3352 9.50257 3.2436 10.0048 3.29507L10.7839 3.26782L11.7883 4.1096C11.7883 4.1096 11.9344 4.21558 11.7883 4.34579L10.0565 6.35941C10.0595 6.36244 9.96824 6.53806 9.8191 6.41694Z" />
    </g>
    <defs>
      <clipPath id="clip0_1525_3459">
        <rect width="11.8576" height="11.8576" fill="white" />
      </clipPath>
    </defs>
  </svg>
)